import { TransportItemType } from '@grafana/faro-web-sdk'
import type { ExceptionEvent, TransportItem } from '@grafana/faro-web-sdk'

export function sanitizeUrl(value: string) {
  return value.split(/[?#]/u)[0]
}

export function sanitizeText(value: string) {
  return value.replace(/https?:\/\/[^\s)]+/gu, sanitizeUrl)
}

export function sanitizeErrorItem(item: TransportItem) {
  if (item.type !== TransportItemType.EXCEPTION) return null

  const payload = item.payload as ExceptionEvent
  const context: Partial<Record<string, string>> = payload.context ?? {}

  return {
    type: item.type,
    meta: {
      app: item.meta.app,
      sdk: item.meta.sdk,
      browser: item.meta.browser,
      os: item.meta.os,
      page: { url: sanitizeUrl(window.location.href) },
    },
    payload: {
      timestamp: payload.timestamp,
      type: payload.type,
      value: sanitizeText(payload.value).slice(0, 4096),
      stacktrace: payload.stacktrace && {
        frames: payload.stacktrace.frames.slice(0, 50).map((frame) => ({
          ...frame,
          filename: sanitizeUrl(frame.filename),
        })),
      },
      context: {
        source: context.source ?? 'unknown',
        component_stack: sanitizeText(context.component_stack ?? '').slice(
          0,
          12000,
        ),
        route: window.location.pathname,
        language: context.language ?? '',
        build: context.build ?? '',
      },
    },
  }
}
